import { render } from "./NavHeader.vue?vue&type=template&id=2efbc702&ts=true"
import script from "./NavHeader.vue?vue&type=script&lang=ts"
export * from "./NavHeader.vue?vue&type=script&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=2efbc702&lang=scss"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__